// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--20kSG";
export var hidden = "styles-module--hidden--1JKbi";